
import { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

// Bump version to force all users through the new onboarding flow.
// Old keys (onboarding_dismissed_at) are effectively ignored.
const COMPLETED_KEY = 'onboarding_v2_completed';

export const useOnboarding = () => {
  const { user } = useAuth();
  const location = useLocation();
  const [needsOnboarding, setNeedsOnboarding] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    if (!user) {
      setIsChecking(false);
      return;
    }

    setIsChecking(true);

    // Simple version check — everyone without the v2 key sees onboarding
    const completed = localStorage.getItem(COMPLETED_KEY);
    setNeedsOnboarding(!completed);
    setIsChecking(false);
  }, [user, location.pathname]);

  const dismissOnboarding = useCallback(() => {
    localStorage.setItem(COMPLETED_KEY, '1');
    setNeedsOnboarding(false);
  }, []);

  return { needsOnboarding, isChecking, dismissOnboarding };
};
